import React, { createContext, useState, useContext, useEffect } from 'react';
import { setLoadingCallbacks } from '../services/api';

const LoadingContext = createContext();

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};

export const LoadingProvider = ({ children }) => {
    const [requestCount, setRequestCount] = useState(0);

    const showLoading = () => {
        setRequestCount(prev => prev + 1);
    };

    const hideLoading = () => {
        setRequestCount(prev => Math.max(0, prev - 1));
    };

    // Configura os callbacks do axios
    useEffect(() => {
        setLoadingCallbacks(showLoading, hideLoading);
    }, []);

    const isLoading = requestCount > 0;

    return (
        <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
            {children}

            {/* Global Loading Overlay */}
            {isLoading && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center">
                    {/* Backdrop */}
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                    {/* Spinner */}
                    <div className="relative z-10 bg-white rounded-2xl p-8 shadow-2xl">
                        <div className="flex flex-col items-center gap-4">
                            <div className="w-16 h-16 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-gray-700 font-medium">Carregando...</p>
                        </div>
                    </div>
                </div>
            )}
        </LoadingContext.Provider>
    );
};

